import { NO_MATCH, DEFAULT_MATCH, POSITIVE_MATCH, NEGATIVE_MATCH } from "./types";

import type { NodeModel } from "@/models/nodes/types";
import type { NodeCondition } from "@corca/data";

export function checkPowerPlacement(
  powerPlacement: NodeCondition["hasPowerPlacement"],
  node?: NodeModel,
): number {
  if (powerPlacement && node && "powerPlacement" in node) {
    if (powerPlacement === node.powerPlacement) {
      return POSITIVE_MATCH;
    }

    if (powerPlacement === `not:${node.powerPlacement}`) {
      return NEGATIVE_MATCH;
    }

    if (!powerPlacement.startsWith("not:")) {
      return NEGATIVE_MATCH;
    }

    return DEFAULT_MATCH;
  }

  return NO_MATCH;
}
